import React, { Component } from 'react';
import { connect } from 'react-redux';
import OddsHistory2 from '..';
import { getTennisEventDetails } from '../../../selectors/matchTimeline';
import { PAGES } from '../../../constants';
import {
  getDownloadedTennisExcelFile, getMatchId,
  getSelectedMarkets, getTennisMarketsDisplayed, getTennisOddDetails,
} from '../../../selectors/oddsHistory';
import { getTennisMarkets, getTennisOddsHistoryTemplate } from '../../../selectors/common';
import { aExportTennisToExcelRequest, aGetTennisOddsDetails } from '../../../reducers';
import { aClearTennisOddsDetails } from '../../../reducers/oddsHistory';

const mapToProps = (state) => ({
  markets: getTennisMarkets(state),
  matchId: getMatchId(state),
  selectedMarkets: getSelectedMarkets(state),
  oddsDetails: getTennisOddDetails(state),
  downloadedExcelFile: getDownloadedTennisExcelFile(state),
  eventDetails: getTennisEventDetails(state),
  oddsHistoryTemplate: getTennisOddsHistoryTemplate(state),
  marketsDisplayed: getTennisMarketsDisplayed(state),

});

const actionsToProps = (dispatch) => ({
  getOddsDetails: (payload) => dispatch(aGetTennisOddsDetails(payload)),
  clearOddsDetails: (payload) => dispatch(aClearTennisOddsDetails(payload)),
  exportToExcel: (payload) => dispatch(aExportTennisToExcelRequest(payload)),
});
class TennisOddsHistory2 extends Component {
  componentDidMount() {
    if (this.props.matchId) {
      this.props.getOddsDetails({
        matchId: this.props.matchId,
        selectedMarkets: this.props.selectedMarkets,
      });
    } else {
      const { pathname } = window.location;
      const matchId = parseInt(pathname.split(`${PAGES.TENNIS_ODDS_HISTORY_STEP_2}/`)[1]);
      window.location.assign(`${PAGES.TENNIS_ODDS_HISTORY_STEP_1}/${matchId}`);
    }
  }

  componentWillUnmount() {
    this.props.clearOddsDetails();
  }

  render() {
    return (
      <OddsHistory2
        eventDetails={this.props.eventDetails}
        exportToExcel={this.props.exportToExcel}
        selectedMarkets={this.props.selectedMarkets}
        oddsDetails={this.props.oddsDetails}
        downloadedExcelFile={this.props.downloadedExcelFile}
        oddsHistoryTemplate={this.props.oddsHistoryTemplate}
        marketsDisplayed={this.props.marketsDisplayed}
        oddsHistoryStep1Page={PAGES.TENNIS_ODDS_HISTORY_STEP_1}
        markets={this.props.markets}
        matchId={this.props.matchId}
        numberOfTitleColumns={4}
        isTennis
      />
    );
  }
}
export default connect(mapToProps, actionsToProps)(TennisOddsHistory2);
